import trainPackCode from "@/config/trainPackCode"
import { getPrestTotalPrice, getPriceAccommodationOnly } from "@/logic/pricesAndDiscount"

export default {
	totals: (state, getters) => {

		const selectedPrestations = getters.selectedPrestations

		const participants = state.participants

		let totalPrice = 0
		let crossedPrice = 0

		if (selectedPrestations.length > 0) {
			const origin = state.flightOrigin ?? trainPackCode.includes(state.packCode) ? 'STP' : 'NA';
			const wiypData = getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(participants.join('-'), origin, state.packCode, selectedPrestations[0].prestation.prestId);
			let firstAccommodation = true;

			selectedPrestations.forEach((prestObj) => {
				const wiypPrice = wiypData?.wiypPrices?.find((w) => w.prestId === prestObj.prestation.prestIdFusion);
				if (wiypPrice && wiypPrice.publicPriceWiyp && wiypPrice.sellingPriceWiyp && wiypPrice.accomPriceWiyp) {
					prestObj.prestation.crossedPrice = wiypPrice.sellingPriceWiyp;
					prestObj.prestation.maxPromo = Math.round(( wiypPrice.publicPriceWiyp - wiypPrice.sellingPriceWiyp) / wiypPrice.publicPriceWiyp * 100);
					prestObj.prestation.pricePerLogement = wiypPrice.sellingPriceWiyp;
					prestObj.prestation.pricePerPerson = wiypPrice.sellingPriceWiyp/participants.length;
					prestObj.prestation.priceAccommodationOnly = wiypPrice.accomPriceWiyp;
				}
				let quantity = prestObj.quantity
				if (firstAccommodation) {
					firstAccommodation = false;
					totalPrice += getPrestTotalPrice(prestObj.prestation);
					crossedPrice += prestObj.prestation.crossedPrice
					quantity -= 1;
				}
				if (prestObj.prestation.priceAccommodationOnly) {
					totalPrice += quantity * getPriceAccommodationOnly(prestObj.prestation);
				} else {
					totalPrice += quantity * getPrestTotalPrice(prestObj.prestation);
				}				
				crossedPrice += quantity * prestObj.prestation.crossedPrice;
			})
		}

		let perPrice = totalPrice / participants.length

		const obj = {}

		obj["totalPrice"] = totalPrice
		obj["perPrice"] = perPrice
		// Because of the wiyp pricing and priceAccommodationOnly, we don't need to calculate the global max promo, except for HS
		let maxPromo = parseInt((1 - totalPrice / crossedPrice) * 100)
		if (state.packCode =='HS' && maxPromo >= 5) obj["crossedPrice"] = crossedPrice
		if (state.packCode =='HS' && maxPromo >= 5) obj["maxPromo"] = maxPromo

		return obj
	},
	// totalsCopy: (state, getters) => {
	// 	const selectedPrestations = getters.selectedPrestations

	// 	const participants = state.participants

	// 	let totalPrice = 0
	// 	let crossedPrice = 0

	// 	let firstAccommodation = true;
	// 	selectedPrestations.forEach((prestObj) => {
	// 		let quantity = prestObj.quantity
	// 		if (firstAccommodation) {
	// 			firstAccommodation = false;
	// 			totalPrice += getPrestTotalPrice(prestObj.prestation);
	// 			crossedPrice += prestObj.prestation.crossedPrice
	// 			quantity -= 1;
	// 		}
	// 		if (prestObj.prestation.priceAccommodationOnly) {
	// 			totalPrice += quantity * getPriceAccommodationOnly(prestObj.prestation);
	// 		} else {
	// 			totalPrice += quantity * getPrestTotalPrice(prestObj.prestation);
	// 		}				
	// 		crossedPrice += quantity * prestObj.prestation.crossedPrice;
	// 	})

	// 	let maxPromo = parseInt((1 - totalPrice / crossedPrice) * 100)

	// 	let perPrice = totalPrice / participants.length

	// 	const obj = {}

	// 	obj["totalPrice"] = totalPrice
	// 	obj["perPrice"] = perPrice
	// 	if (maxPromo >= 5) obj["crossedPrice"] = crossedPrice
	// 	if (maxPromo >= 5) obj["maxPromo"] = maxPromo

	// 	return obj
	// },
}
